import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PlatformEnum } from '@panamax/app-state';
import { BasicListItem } from '@shared/models/dual-pane-model';

@Component({
  selector: 'app-ingredient-detail-touch-actions',
  templateUrl: './ingredient-detail-touch-actions.component.html',
  styleUrls: [
    './ingredient-detail-touch-actions.component.scss',
    '../../../../styles/shared-mpp-styles.scss',
  ],
})
export class IngredientDetailTouchActionsComponent {
  @Output() tabSelectedEvent = new EventEmitter<string>();
  @Input() platform: PlatformEnum;
  @Input() dataItems: BasicListItem[] = [];
  @Input() title: string;
  @Input() selectedTab: string;
  constructor() {}

  handleTabSelection(item: BasicListItem) {
    this.tabSelectedEvent.emit(item.value);
  }

  handleBackButton(item: string) {
    this.tabSelectedEvent.emit(item);
  }
}
